



































































import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'

export default
  name: 'CategoriesEditor'
  components:
    transaction_amount: require('components/inside/pages/transactions/transaction_amount.vue').default
  data: ->
    edited: {}
    loading: false
    filter: ''
  computed:
    all_categories: -> @$store.getters.transactions_categories_without_base_categories
    filtered_categories: ->
      @all_categories.filter (category) =>
        (category.name || '').toLowerCase().includes(@filter.toLowerCase())
    category_trs: ->
      @$store.state.user.transactions.filter (tr) => tr.category == @edited.name
    limited_category_trs: ->  _.takeRight(@category_trs, 50).reverse()
    transactions_stats: ->
      return '' if @limited_category_trs.length == @category_trs.length
      return "(#{@limited_category_trs.length} #{@$t('from')} #{@category_trs.length})"
    is_hidden: -> (category) -> @$store.getters.hidden_categories.includes(category.name)
  methods:
    isEdited: (category) -> @edited.name == category.name
    edit: (category) ->
      @$store.dispatch('hideTransactionsPopovers')
      @edited = _.clone(category)
      @edited.new_name = @edited.name
      @$nextTick -> $('#new_category_name').focus()
    select: (transaction) -> @$store.dispatch 'selectTransaction', transaction
    close: ->
      @$emit('close')
    save: ->
      HM.track 'transaction-rename_category'
      transactions = @$store.state.user.transactions.filter (tr) => tr.category == @edited.name
      @loading = true
      new_category = @edited.new_name.split('/').map((cat) -> cat.trim()).join(' / ')
      HM_API.bulk_update_transactions({
        transaction_ids: _.map(transactions, 'id')
        new_category: new_category
      }).then =>
        for tr in transactions
          tr.category = new_category
        @$message { type: 'success', message: @$t('Done') }
        @loading = false
        @edited.name = new_category
    hide: (category) -> HM.store.dispatch('hideCategory', category.name)
    show: (category) -> HM.store.dispatch('showCategory', category.name)
